<script setup lang="ts">
const props = defineProps<{
  type?: 'text' | 'password' | 'email';
  placeholder?: string;
  isError?: boolean;
  inactive?: boolean;
  errorHintText?: string;
  minlength?: number;
  autocomplete?: string;
}>();

const inputRef = ref<HTMLInputElement>();
defineExpose({ input: inputRef });

const minlength = computed(() => props.minlength || (props.type === 'password' ? 8 : 0));

const text = defineModel<string>('modelValue', { default: '' });
</script>

<template>
  <div class="flex flex-col flex-nowrap gap-1">
    <TextInput
      ref="inputRef"
      v-model="text"
      :autocomplete="autocomplete"
      :minlength="minlength"
      :type="type"
      :placeholder="placeholder"
      :is-error="isError"
      :inactive="inactive"
    />
    <div
      v-if="!!errorHintText"
      class="text-hint font-normal text-red-500 min-h-[13px]"
    >
      {{ !inactive && isError ? errorHintText : '' }}
    </div>
  </div>
</template>

<style scoped>

</style>
